import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  all: initial;
  display: block;
  background-color: ${({ color }) => color || '#002391'};
  padding: 12px 15px;
  color: white;
  font-weight: 500 !important;
  margin: 15px 0 20px;
  font-size: 15px !important;
`;

const Head = ({ children, color }) => (
  <Container color={color}>
    {children}
  </Container>
);

export default Head;
